<template>
    <div class="sustainable-component admin-users-department">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-users-department</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row mb-3">
                <div class="col-12 p-0">
                    <CommonLabelContainer title="Skapa användare" class="mt-5 mb-3">
                        <v-form v-model="valid" ref="form">
                            <div class="container-fluid p-0">
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="Username"
                                                                  id="Username"
                                                                  type="text"
                                                                  label="Användarnamn"
                                                                  variant="outlined"
                                                                  v-model="user.Username"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="Password"
                                                                  id="Password"
                                                                  type="text"
                                                                  label="Lösenord"
                                                                  variant="outlined"
                                                                  v-model="user.Password"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name="Email"
                                                                  id="Email"
                                                                  type="text"
                                                                  label="E-post"
                                                                  variant="outlined"
                                                                  v-model="user.Email"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">

                                                    <v-select name="Department" v-model="user.DepartmentId" id="department" item-title="DepartmentName" item-value="DepartmentId" :items="departments" label="Avdelning">

                                                    </v-select>

                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="Club" v-model="user.ClubId" item-title="ClubName" item-value="ClubId" :items="clubs" label="Klubb">

                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-select name="WorkSpace" :rules="[rules.required]" v-model="user.WorkspaceId" item-title="WorkspaceName" item-value="WorkspaceId" :items="workspaces" label="Arbetsplats">

                                                    </v-select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="container-fluid p-0">
                                            <div class="row">
                                                <div class="col">
                                                    <v-select :rules="[rules.required]" name="PermissionLevel" v-model="user.PermissionLevel" :items="permissionLevels" label="Behörighet">

                                                    </v-select>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <v-text-field bg-color="white"
                                                                  :rules="[rules.required]"
                                                                  name=""
                                                                  id=""
                                                                  type="text"
                                                                  label="Företag"
                                                                  variant="outlined"
                                                                  v-model="user.VirtualCompany"
                                                                  focused="true"></v-text-field>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <v-btn variant="tonal" @click="createUser" class="bg-primary">
                                            Skapa
                                        </v-btn>
                                    </div>
                                </div>
                            </div>
                        </v-form>
                    </CommonLabelContainer>
                </div>
            </div>
            <div class="row table-space">
                <b>Visar {{users.length}} användare</b>
                <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                    <thead>
                        <tr>
                            <th class="col-2">Id</th>
                            <th class="col-2">Namn</th>
                            <th class="col-2">Email</th>
                            <th class="col-2">Arbetsplats</th>
                            <th class="col-2">Behörighet</th>
                            <th class="col-2"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in getUsers()" :key="index">
                            <td>{{item.UserId}}</td>
                            <td>{{item.Username}}</td>
                            <td>{{item.Email}}</td>
                            <td>{{item.WorkspaceName}}</td>
                            <td>{{item.RWRPermissionLevel}}</td>
                            <td valign="middle">
                                <div class="pull-right" style="">
                                    <div class="dropdown text-right pr-2">
                                        <a href="#" class="drop" data-bs-toggle="dropdown" aria-expanded="false">
                                            ...
                                        </a>
                                        <div class="dropdown-menu dropdown-menu-right">
                                            <a href="javascript:void(0)" class="dropdown-item" @click="updateUser(item)">Ändra</a>
                                            <a href="javascript:void(0)" class="dropdown-item" @click="deleteUser(item.UserId)">Ta bort</a>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
        <UpdateUserDepartment ref="updateUserDepartmentModal" @updated="loadUsers"></UpdateUserDepartment>
    </div>
</template>


<script>

    import ValidationService from "../../Services/ValidationService";
    import AdminService from "../../Services/AdminService";
    import CommonLabelContainer from "../../common/common-label-container";
    import UpdateUserDepartment from './update/update-user-department.vue'
    import CommonSpinner from '../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);
    const updateUserDepartmentModal = ref(null);

    export default {

        name: 'admin-users-department',
        props: {

        },
        components: {
            UpdateUserDepartment,
            CommonLabelContainer,
            CommonSpinner
        },
        methods: {
            async createUser() {
                var result = await this.form.validate()
                if (result.valid != true)
                    return;
                this.loading++;
                try {
                    await AdminService.createUserDepartment(this.user);
                    this.displaySnackBar("Användaren skapades");
                    this.loadUsers();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                }
                this.loading--;
            },
            async loadUsers() {
                this.loading++;
                try {
                    this.users = await AdminService.getWorkspaceUsers();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async updateUser(user) {
                this.loading++;
                this.updateUserDepartmentModal.open(user)
                this.loading--;
            },
            async loadDepartments() {
                this.loading++;
                try {
                    this.departments = await AdminService.getDepartments();
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadClubs(departmentId) {
                this.loading++;
                try {
                    this.clubs = await AdminService.getClubsFromDepartment(departmentId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async loadWorkspaces(clubId) {
                this.loading++;
                try {
                    this.workspaces = await AdminService.getWorkspacesFromClub(clubId);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            async deleteUser(userId) {
                if (confirm("Är du säker att du vill radera användaren?")) {
                    this.loading++;
                    try {
                        await AdminService.deleteUser(userId);
                        this.displaySnackBar("Användaren togs bort");
                        this.loadUsers();
                    }
                    catch (error) {
                        this.displayErrorSnackBar("Ett oväntat fel har inträffat")
                    }
                    this.loading--;
                }
            },
            getUsers() {
                return this.users;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                rules: ValidationService.rules(),
                userloaded: false,
                user: {
                    DepartmentId: 0,
                    ClubId: 0,
                    WorkspaceId:0,
                },
                permissionLevels: [{ title: "Avdelningsadministratör", value: 15 },{ title: "Administratör", value: 20 }, { title: "Användare", value: 30 }, { title: "Läsare", value: 40 }],
                users:[],
                departments: [],
                clubs: [],
                workspaces: [],
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
                loading: 0,
            };
        },
        watch: {
            'user.DepartmentId': function (newVal) {
                this.user.ClubId = null;
                this.user.WorkspaceId = null;
                this.loadClubs(newVal);
            },
            'user.ClubId': function (newVal) {
                this.user.WorkspaceId = null;
                this.loadWorkspaces(newVal)
            },
        },
        mounted() {
            this.loadUsers();
            this.loadDepartments();
        },
        setup() {
            return { form, updateUserDepartmentModal }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>